function changeActiveFilterSlide(carousel) {
  const swiperWrapper = document.querySelector(
    '.filters-carousel .facetwp-facet'
  );
  const filtersRadio = document.querySelectorAll('.facetwp-radio');

  filtersRadio.forEach((radioBtn) => {
    radioBtn.addEventListener('click', function () {
      const radioBtnIndex = Array.prototype.indexOf.call(
        swiperWrapper.children,
        radioBtn
      );
      carousel.slideTo(radioBtnIndex);
    });
  });
}

window.addEventListener('load', function () {
  const Swiper = window.Swiper;
  const filters = document.querySelector('.articles-filters.filters-carousel');

  if (filters) {
    const filtersCarousel = new Swiper('.articles-filters.filters-carousel', {
      wrapperClass: 'facetwp-facet',
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      slideClass: 'facetwp-radio',
      watchOverflow: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    });

    changeActiveFilterSlide(filtersCarousel);

    window.addEventListener('facetwp-loaded', function () {
      changeActiveFilterSlide(filtersCarousel);
    });
  }

  // Scroll to top when page change
  document.addEventListener('facetwp-loaded', function () {
    window.scrollTo(0, 0);
  });
});
